<template>
  <article
    v-if="garage"
    class="garage-header"
  >
    <h1 class="garage-header__garage-name">{{ garage.name }}</h1>

    <div class="garage-header__wrapper">
      <div class="garage-header__rating">
        <div class="garage-header__rating-stars">
          <NuxtImg
            v-for="(item, index) in 6"
            width="18px"
            height="18px"
            class="garage-header__rating-star"
            alt="Ocena DobryMechanik.pl"
            :src="getStar(garage.ratingTotal || 0, index).toString()"
          />
        </div>
        <span class="garage-header__rating-total">{{ garage.ratingTotal }}</span>

        <span
          :href="`#${Tabs.Opinions}/`"
          class="garage-header__total-comments"
          @click="emits('go-to-tab', Tabs.Opinions)"
        >
          ({{ totalComments }} {{ getCommentsTranslatePL(totalComments) }})
        </span>
      </div>

      <div>
        <p class="garage-header__address">
          {{ garage.address }},
          <a
            v-if="garage.quarter"
            :href="`/mechanicy/${route.params.city}/dzielnica/${garage.quarterSlug}/`"
          >
            {{ garage.quarter }}
          </a>
          <span v-if="garage.quarter">, </span>
          <a :href="`/mechanicy/${route.params.city}/`">
            {{ garage.city }}
          </a>
        </p>
      </div>
    </div>
  </article>
</template>

<script setup lang="ts">
import { getStar } from '@/helpers/get-star';
import type { GarageJsonldGarageReadGarageReadIdGarageReadNameGarageSlugHistoryReadSuggestedGarageRead } from '~/api/docs/api';
import { Tabs } from '@/models/enums';
import type { GarageCommentStatistics } from '~/api/docs/app';
import { getCommentsTranslatePL } from '@/helpers/helpers';

interface IProps {
  garage?: GarageJsonldGarageReadGarageReadIdGarageReadNameGarageSlugHistoryReadSuggestedGarageRead;
  totalComments?: number;
}

interface IEmits {
  (name: 'go-to-tab', value: Tabs): void;
}

// use
const route = useRoute();

// emits
const emits = defineEmits<IEmits>();

const props = defineProps<IProps>();
</script>

<style lang="scss" scoped>
@import url('assets/styles/components/garage-header.scss');
</style>